import { Component, ViewChild } from '@angular/core';
import { MediaService } from '../../services/media.service';
import { HttpEventType } from '@angular/common/http';
import { Media } from '@contracts/interfaces/media.interfaces';
import { SocialsService } from '../../services/socials.service';
import { SocialAsset } from '@contracts/interfaces/socials.interface';
import { ConnectionService } from '../../services/connection.service';
import { NgxMasonryComponent, NgxMasonryOptions } from 'ngx-masonry';

@Component({
  selector: 'app-socials',
  templateUrl: './socials.component.html',
  styleUrls: ['./socials.component.scss']
})
export class SocialsComponent {
  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;

  socialAssets: SocialAsset[] = [];

  public masonryOptions: NgxMasonryOptions = {
    gutter: 5,
    fitWidth: true,
  };

  constructor(
    private mediaService: MediaService,
    private socialsService: SocialsService,
    private connectionService: ConnectionService) {
  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.socialsService.list().subscribe((socialAssets: SocialAsset[]) => {
      this.socialAssets = socialAssets;

      setTimeout(() => {
        this.masonry.reloadItems();
        this.masonry.layout();
      }, 500)

    })
  }

  imageFiles: any[] = [];
  startUploadImage(evt) {

    for (let image of evt.addedFiles) {
      image.percentage = 0;
      image.totalSize = 0;
      this.imageFiles.push(image)
    }

    this.uploadImage();
  }

  uploadImage() {

    if (this.imageFiles.length > 0) {
      
      let image: Media = {
        filename: this.imageFiles[0].name,
        path: "social-assets/"
      }

      this.mediaService.upload(this.imageFiles[0], image).subscribe((reply) => {

        if (reply.type === HttpEventType.UploadProgress) {
          this.imageFiles[0].percentage = (reply.loaded / 1000 / 1000).toFixed(2);
          this.imageFiles[0].totalSize = (reply.total / 1000 / 1000).toFixed(2);
        }
        if (reply.type === HttpEventType.DownloadProgress) {
  
        }
        if (reply.type === HttpEventType.Response) {
          // if image uploadeded successfully
          if (reply.body) {
            this.socialsService.create({
              filename: reply.body['filename'],
              dateAdded: new Date()
            }).subscribe((r: any)=>{
              this.socialAssets.unshift(r.socialAsset);
              this.imageFiles = [];

              setTimeout(() => {
                this.masonry.reloadItems();
                this.masonry.layout();
              }, 500)
            })
          }
        }
      })
    }
  }

  getUrl(socialAsset: SocialAsset) {
    return this.connectionService.address + "/social-assets/" + socialAsset.filename + "?width=350&height=350&fit=cover&background=rgb(250,250,250)";
  }

  deleteSocialAsset (socialAsset: SocialAsset) {
    this.socialsService.delete(socialAsset).subscribe((r) => {
      for (let i=0; i < this.socialAssets.length; i++) {
        if (this.socialAssets[i]._id == socialAsset._id) {
          this.socialAssets.splice(i, 1);
        }
      }
    });
  }

  openImageDialog(socialAsset: SocialAsset, index) {

    let temp: Media[] = [];

    for (let socialAsset of this.socialAssets) {
      temp.push({
        filename: socialAsset.filename,
        path: "social-assets/",
      })
    }

    this.mediaService.edit({
      filename: socialAsset.filename,
      path: "social-assets"
    }, (r) => {
      
      if (r.type == "deleted") {
        this.deleteSocialAsset(socialAsset);
      }

      if (r.type == "error") {
        if (r.image == undefined) {
          this.deleteSocialAsset(socialAsset);
        }
      }
    }, {
      list: temp,
      index: index,
      view: true
    })
  }
}
